export const state = () => ({
  wish_lists: [],
  error_message: '',
})

export const mutations = {
  setWishLists(state, wish_lists) {
    state.wish_lists = wish_lists
  },
  setErrorMessage(state, error_message) {
    state.error_message = error_message
  },
}

export const actions = {
  async getWishLists({ commit }) {
    await this.$axios
      .$get('/product_wishlist')
      .then((response) => {
        let wish_lists = response.data
        commit('setWishLists', wish_lists)
      })
      .catch((error) => {
        commit('setErrorMessage', error)
      })
  },
}
